var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"org"},[_c('v-card',{staticClass:"org-card",attrs:{"to":{ name: 'Organization', params: { id: _vm.org.id } }}},[_c('v-img',{staticClass:"image",attrs:{"src":_setup.getOrgImage(_vm.org.image, 300)}})],1),_c('span',{staticClass:"org-name"},[_vm._v(" "+_vm._s(_vm.org.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }